import React from 'react';

type DetailsSectionWrapperProps = { children: React.ReactNode };

const DetailsSectionWrapper = ({ children }: DetailsSectionWrapperProps) => {
  return <div className="flex flex-col max-w-512 mx-auto">{children}</div>;
};

export default DetailsSectionWrapper;
